import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'

export const Container = styled.div`
  width: 100%;
`

export const Header = styled.header`
  display: flex;
  width: 100%;
  height: 71px;
  flex-direction: row;
  align-items: center;
  padding: 23px 30px;
  justify-content: space-between;
  background-color: ${colors.green};
  z-index: 99;

  position: relative;
`

export const Logo = styled.img`
  width: 130px;
  height: 37.49px;
`

export const ContainerItem = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
`

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const GridContainer = styled(Grid)`
  height: 61px;
`

export const TextTime = styled.p`
  color: ${colors.black};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${colors.grayLight};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 0;
  width: 100%;
  text-align: center;
  background-color: ${colors.grayLight4};
  padding: 10px;
`

export const Text = styled.p`
  color: ${colors.black};
  font-size: 14px;
  font-weight: 600;
`

export const TextType = styled.p`
  color: ${colors.grayDark};
  font-size: 12px;
  line-height: 20px;

  margin: 5px 0px;
`

export const TextDoc = styled.p`
  color: ${colors.blue};
  font-size: 12px;
  font-weight: 700;

  & > span {
    color: ${colors.grayDark};
    font-size: 12px;
    font-weight: 400;
  }
`

export const TextHeaderBold = styled.span`
  color: ${colors.white};
  font-size: 12px;
  font-weight: 600;
  padding: 0 4px;
`

export const TextHeader = styled.span`
  color: ${colors.white};
  font-size: 12px;
  font-weight: 400;
  padding: 0 4px;
`

export const TextDateExtrato = styled.p`
  color: ${colors.black};
  font-size: 14px;
  font-weight: 600;
`

export const ContainerAccountData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const CardType = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;

  width: 50px;
  height: 16px;

  background: ${colors.blue};

  font-size: 8px;
  color: ${colors.white};

  border-radius: 2px;

  text-transform: uppercase;
`

interface ITotalValueProps {
  isValorFinal: boolean
}
export const TotalValue = styled.span<ITotalValueProps>`
  color: ${props => (props.isValorFinal ? colors.green : colors.black)};
  font-size: 24px;
  font-weight: 700;
`

interface IMoneyValueProps {
  isDebit: boolean
}
export const MoneyValue = styled.span<IMoneyValueProps>`
  color: ${props => (props.isDebit ? colors.red : colors.green)};
  font-size: 12px;
  font-weight: 700;
`
